import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BaseCustomerInquiryOfferShiftInterface,
  BaseInquiryShiftsWithFlexType,
  OfferBubbleValues,
  OfferBubbleValueTranslationKeys,
} from 'base';

@Component({
  selector: 'base-customer-offer-bubble',
  templateUrl: './base-customer-offer-bubble.component.html',
})
export class BaseCustomerOfferBubbleComponent implements OnInit {
  @Input() bubble: BaseCustomerInquiryOfferShiftInterface;
  @Input() isOfferSelected: boolean;
  @Output() bubbleClick: EventEmitter<BaseInquiryShiftsWithFlexType> =
    new EventEmitter<BaseInquiryShiftsWithFlexType>();

  bubbleTranslationKeys: any;

  ngOnInit(): void {
    this.bubbleTranslationKeys = OfferBubbleValueTranslationKeys;
  }

  onBubbleClick(event: Event): void {
    event.stopPropagation();
    if (this.isOfferSelected && this.bubble.currentValue === OfferBubbleValues.OfferedByServiceProvider) {
      this.bubbleClick.emit(this.bubble.shift);
    }
  }
}
